import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoLocationSharp, IoClose } from "react-icons/io5";
import { FiSearch, FiMapPin, FiTruck } from "react-icons/fi";
import { MdLocalShipping, MdOutlineSpeed, MdLocalGasStation, MdPerson } from "react-icons/md";
import "../styles/Test.css";

const Test = () => {
  const navigate = useNavigate();

  // Mock fleet data
  const initialVehicles = [
    { 
      id: 1, 
      name: "Volvo FMX 440", 
      regNo: "VH-482", 
      status: "active", 
      type: "Heavy Dumper", 
      lat: 45, 
      lng: 40, 
      speed: "64 km/h", 
      fuel: "78%", 
      driver: "Ahsan Khan", 
      location: "Route 66, Sector A",
      logs: [
        { time: "12:24:10", text: "GPS Ping Received - Signal Strong" },
        { time: "12:20:05", text: "Speed normalization: 64 km/h" },
        { time: "12:15:40", text: "Fuel level sensor updated: 78%" }
      ]
    },
    { 
      id: 2, 
      name: "Scania R 450", 
      regNo: "VH-912", 
      status: "active", 
      type: "Logistics Trailer", 
      lat: 25, 
      lng: 60, 
      speed: "82 km/h", 
      fuel: "54%", 
      driver: "Bilal Shafi", 
      location: "GT Road Near Toll Plaza",
      logs: [
        { time: "12:24:35", text: "Overspeed warning triggered", alert: true },
        { time: "12:24:30", text: "GPS Ping Received - Signal Strong" },
        { time: "12:19:12", text: "Entered Route Zone: GT-1" }
      ]
    },
    { 
      id: 3, 
      name: "Toyota Hilux", 
      regNo: "VH-105", 
      status: "idle", 
      type: "Utility Support Unit", 
      lat: 70, 
      lng: 30, 
      speed: "0 km/h", 
      fuel: "92%", 
      driver: "Zahid Ali", 
      location: "Main Head Office Garage",
      logs: [
        { time: "12:23:55", text: "Engine idling for over 10 mins", alert: true },
        { time: "12:13:00", text: "Vehicle parked at HQ" }
      ]
    },
    { 
      id: 4, 
      name: "Mercedes Actros", 
      regNo: "VH-334", 
      status: "offline", 
      type: "Heavy Transport Dumper", 
      lat: 80, 
      lng: 75, 
      speed: "0 km/h", 
      fuel: "21%", 
      driver: "Imran Raza", 
      location: "Central Maintenance Workshop Bay 3",
      logs: [
        { time: "11:45:00", text: "Connection lost - Power Save Mode" },
        { time: "11:40:12", text: "Parked in Workshop Bay 3" }
      ]
    },
    { 
      id: 5, 
      name: "Isuzu Forward", 
      regNo: "VH-774", 
      status: "active", 
      type: "Medium Cargo Van", 
      lat: 60, 
      lng: 80, 
      speed: "45 km/h", 
      fuel: "60%", 
      driver: "Sohail Ahmed", 
      location: "Industrial Area Gate 1",
      logs: [
        { time: "12:24:50", text: "GPS Ping Received - Signal Strong" },
        { time: "12:22:15", text: "Departed Warehouse Hub" }
      ]
    }
  ];

  const [vehicles, setVehicles] = useState(initialVehicles);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [isTracking, setIsTracking] = useState(false);
  const [loadingMap, setLoadingMap] = useState(false);
  const [activeVehicle, setActiveVehicle] = useState(null);

  // Search filter
  const filteredVehicles = vehicles.filter(v => 
    v.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    v.regNo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle vehicle select
  const handleToggleSelect = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(item => item !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  // Start tracking
  const handleTrackSelected = () => {
    if (selectedIds.length === 0) return;
    setLoadingMap(true);
    setIsTracking(true);
    setActiveVehicle(null);

    // Simulate map loading animation
    setTimeout(() => {
      setLoadingMap(false);
    }, 1200);
  };

  // Stop tracking
  const handleReset = () => {
    setIsTracking(false);
    setSelectedIds([]);
    setActiveVehicle(null);
  };

  return (
    <div className="test_dashboard_container">
      {/* LEFT SIDEBAR */}
      <div className="test_sidebar">
        <div className="test_sidebar_header">
          <h3>Fleet Operations</h3>
          <div className="test_search_box">
            <FiSearch className="test_search_icon" />
            <input 
              type="text" 
              placeholder="Search fleet (e.g. Volvo, Scania)" 
              className="test_search_input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="test_fleet_list">
          {filteredVehicles.map(vehicle => {
            const isChecked = selectedIds.includes(vehicle.id);
            return (
              <div 
                key={vehicle.id} 
                className={`test_fleet_item ${isChecked ? "selected" : ""}`}
                onClick={() => handleToggleSelect(vehicle.id)}
              >
                <input 
                  type="checkbox" 
                  checked={isChecked}
                  onChange={() => {}} // Controlled by item click
                  className="test_fleet_checkbox"
                  onClick={(e) => e.stopPropagation()} 
                />
                <div className="test_fleet_icon">
                  <MdLocalShipping />
                </div>
                <div className="test_fleet_info">
                  <div className="test_vehicle_name">{vehicle.name}</div>
                  <div className="test_vehicle_type">{vehicle.type} • {vehicle.regNo}</div>
                </div>
                <div className={`test_status_badge ${vehicle.status}`}>
                  {vehicle.status}
                </div>
              </div>
            );
          })}
          {filteredVehicles.length === 0 && (
            <div style={{ textAlign: "center", color: "#999", padding: "20px" }}>
              No vehicles match search criteria.
            </div>
          )}
        </div>

        <div className="test_sidebar_footer">
          {isTracking ? (
            <button 
              className="test_track_button" 
              onClick={handleReset}
              style={{ backgroundColor: "#e53e3e" }}
            >
              Clear Live Tracking
            </button>
          ) : (
            <button 
              className="test_track_button" 
              onClick={handleTrackSelected}
              disabled={selectedIds.length === 0}
            >
              Track Selected ({selectedIds.length})
            </button>
          )}
        </div>
      </div>

      {/* MAP / DEMO VIEW AREA */}
      <div className="test_map_area">
        {/* If not tracking: Render Figma exact design placeholder */}
        {!isTracking && (
          <>
            {/* Blurred background map mock */}
            <div className="test_blurred_map_bg">
              <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#a7f3d0" strokeWidth="1" opacity="0.4"/>
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#grid)" />
                {/* Curved paths representing roads */}
                <path d="M-100,200 C300,100 200,400 900,300" fill="none" stroke="#d1fae5" strokeWidth="20" opacity="0.6"/>
                <path d="M100,-50 C300,300 400,100 800,600" fill="none" stroke="#d1fae5" strokeWidth="16" opacity="0.6"/>
              </svg>
            </div>

            {/* The exact Card from Figma */}
            <div className="test_figma_placeholder_wrapper">
              <div className="figma_card" data-node-id="9281:2467">
                <div className="figma_inner_container" data-node-id="9281:2441">
                  <div className="figma_header_stack" data-node-id="9281:2468">
                    <div className="figma_icon_badge" data-node-id="9281:2442" data-name="Background">
                      <div className="figma_icon" data-node-id="9281:2443" data-name="SVG">
                        <IoLocationSharp />
                      </div>
                    </div>
                    
                    <div className="figma_title_container" data-node-id="9281:2446" data-name="Container">
                      <h3 className="figma_title" data-node-id="9281:2447">
                        Select Vehicles to Start<br />Live Tracking
                      </h3>
                    </div>

                    <div className="figma_desc_container" data-node-id="9281:2448" data-name="Container">
                      <p className="figma_desc" data-node-id="9281:2449">
                        Map API is not loaded until you select specific vehicles. This keeps the experience fast and cost-efficient.
                      </p>
                    </div>
                  </div>

                  <div className="figma_steps_stack" data-node-id="9281:2450" data-name="Container">
                    {/* Step 1 */}
                    <div className="figma_step_row" data-node-id="9281:2451" data-name="Container">
                      <div className="figma_step_number_badge" data-node-id="9281:2452" data-name="Background">
                        <p className="figma_step_number" data-node-id="9281:2453">1</p>
                      </div>
                      <div className="figma_step_text_container" data-node-id="9281:2454" data-name="Container">
                        <p className="figma_step_text" data-node-id="9281:2455">
                          Check vehicles from the fleet list on the left
                        </p>
                      </div>
                    </div>

                    {/* Step 2 */}
                    <div className="figma_step_row" data-node-id="9281:2456" data-name="Container">
                      <div className="figma_step_number_badge" data-node-id="9281:2457" data-name="Background">
                        <p className="figma_step_number" data-node-id="9281:2458">2</p>
                      </div>
                      <div className="figma_step_text_container" data-node-id="9281:2459" data-name="Container">
                        <p className="figma_step_text" data-node-id="9281:2460">
                          Click "Track Selected" to load map & markers
                        </p>
                      </div>
                    </div>

                    {/* Step 3 */}
                    <div className="figma_step_row" data-node-id="9281:2461" data-name="Container">
                      <div className="figma_step_number_badge" data-node-id="9281:2462" data-name="Background">
                        <p className="figma_step_number" data-node-id="9281:2463">3</p>
                      </div>
                      <div className="figma_step_text_container" data-node-id="9281:2464" data-name="Container">
                        <p className="figma_step_text" data-node-id="9281:2465">
                          Click any marker to view vehicle logs & trip details
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </>
        )}

        {/* If Tracking but Loading: Render gorgeous loading spinner */}
        {isTracking && loadingMap && (
          <div className="test_map_loading">
            <div className="test_spinner"></div>
            <div style={{ fontWeight: 600, fontSize: "14px", fontFamily: "Raleway" }}>
              Connecting Live Telemetry Server...
            </div>
          </div>
        )}

        {/* If Tracking and Done Loading: Render custom interactive vector map dashboard */}
        {isTracking && !loadingMap && (
          <>
            {/* The Interactive Mock Map */}
            <div className="test_mock_map">
              <div className="test_map_grid_overlay"></div>
              
              <svg width="100%" height="100%" className="test_map_svg_layer">
                {/* Major routes */}
                <path d="M 100 100 Q 350 50 600 200 T 900 600" className="test_map_svg_road" />
                <path d="M 100 100 Q 350 50 600 200 T 900 600" className="test_map_svg_road_center" />
                
                <path d="M 50 500 C 250 400 400 600 850 350" className="test_map_svg_road" />
                <path d="M 50 500 C 250 400 400 600 850 350" className="test_map_svg_road_center" />

                {/* Draw Route for Selected Vehicle (if active) */}
                {activeVehicle && (
                  <path 
                    d={`M 100 100 Q ${activeVehicle.lng * 8} ${activeVehicle.lat * 5} ${activeVehicle.lng * 10} ${activeVehicle.lat * 6}`}
                    className="test_map_svg_route"
                  />
                )}
              </svg>

              {/* Vehicle Marker Pins */}
              {vehicles
                .filter(v => selectedIds.includes(v.id))
                .map(v => (
                  <div 
                    key={v.id}
                    className="test_map_marker"
                    style={{ left: `${v.lng}%`, top: `${v.lat}%` }}
                    onClick={() => setActiveVehicle(v)}
                  >
                    <div className="test_marker_pin" style={{ backgroundColor: activeVehicle?.id === v.id ? "#319795" : "#1447b1" }}>
                      <div className="test_marker_pin_inner">
                        <FiTruck />
                      </div>
                    </div>
                    <div className="test_marker_pulse"></div>
                    <div style={{ 
                      position: "absolute", 
                      top: "35px", 
                      left: "50%", 
                      transform: "translateX(-50%)",
                      backgroundColor: "rgba(26, 28, 61, 0.85)", 
                      color: "#fff",
                      fontSize: "9px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      whiteSpace: "nowrap",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      fontWeight: 600
                    }}>
                      {v.regNo}
                    </div>
                  </div>
                ))}
            </div>

            {/* Left/Bottom Float info message */}
            <div style={{
              position: "absolute",
              bottom: "20px",
              left: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              padding: "10px 16px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              zIndex: 5,
              fontSize: "12px",
              fontWeight: 500
            }}>
              💡 Click any vehicle pin on the map to inspect telemetry & logs.
            </div>

            {/* TELEMETRY DETAIL PANEL (Slide-in) */}
            {activeVehicle && (
              <div className="test_detail_panel">
                <div className="test_panel_header">
                  <div className="test_panel_header_title">
                    <div className="figma_icon_badge" style={{ width: "36px", height: "36px" }}>
                      <FiTruck style={{ color: "#1447b1", fontSize: "18px" }} />
                    </div>
                    <div>
                      <h4 style={{ margin: 0, fontSize: "14px", fontWeight: 700, color: "#1a1c3d" }}>
                        {activeVehicle.name}
                      </h4>
                      <span style={{ fontSize: "11px", color: "#718096" }}>{activeVehicle.regNo} • {activeVehicle.type}</span>
                    </div>
                  </div>
                  <button className="test_panel_close" onClick={() => setActiveVehicle(null)}>
                    <IoClose />
                  </button>
                </div>

                <div className="test_telemetry_stats">
                  <div className="test_stat_card">
                    <span className="test_stat_label"><MdOutlineSpeed style={{ marginRight: "4px" }} /> Speed</span>
                    <span className="test_stat_value" style={{ color: activeVehicle.speed === "0 km/h" ? "#718096" : "#319795" }}>
                      {activeVehicle.speed}
                    </span>
                  </div>
                  <div className="test_stat_card">
                    <span className="test_stat_label"><MdLocalGasStation style={{ marginRight: "4px" }} /> Fuel Level</span>
                    <span className="test_stat_value">{activeVehicle.fuel}</span>
                  </div>
                  <div className="test_stat_card" style={{ gridColumn: "span 2" }}>
                    <span className="test_stat_label"><MdPerson style={{ marginRight: "4px" }} /> Driver Assignment</span>
                    <span className="test_stat_value" style={{ fontSize: "13px" }}>{activeVehicle.driver}</span>
                  </div>
                  <div className="test_stat_card" style={{ gridColumn: "span 2" }}>
                    <span className="test_stat_label"><FiMapPin style={{ marginRight: "4px" }} /> Last Known Coordinates</span>
                    <span className="test_stat_value" style={{ fontSize: "11px", fontWeight: "normal", color: "#4a5568" }}>
                      {activeVehicle.location}
                    </span>
                  </div>
                </div>

                <div className="test_log_section">
                  <h4>Telemetry Event Logs</h4>
                  <div className="test_log_list">
                    {activeVehicle.logs.map((log, index) => (
                      <div key={index} className="test_log_item">
                        <div className={`test_log_bullet ${log.alert ? "alert" : ""}`}></div>
                        <div className="test_log_time">{log.time}</div>
                        <div className="test_log_text">{log.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Test;
